import { getTranslations } from 'next-intl/server';
import { currencyFormatter, LabelFormats, NumberFormats } from '../../utils/currencyFormatter';

/**
 * Helper methodthat provides both formatter and translations for currency formatting
 * @returns Object containing formatter and translations for currency formatting
 */
const getCurrencyFormatter = async () => {
  const t = await getTranslations('general');

  return currencyFormatter(t);
};

export { getCurrencyFormatter, LabelFormats, NumberFormats };
